<script>
import axios from "axios";
// axios.defaults.baseURL = 'http://127.0.0.1:8000/api';
axios.defaults.baseURL = 'https://admin.ovvura.ae/api';

const token = localStorage.getItem("token");
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  } else {
    axios.defaults.headers.common["Authorization"] = "";
    axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  }

import appConfig from "@/app.config";
export default {
  name: "app",
  page: {
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  mounted() {
    this.$getLocation({
    enableHighAccuracy: true, //defaults to false
    timeout: Infinity, //defaults to Infinity
    maximumAge: 0 //defaults to 0
    }).then(coordinates => {
    localStorage.removeItem('coordinates')
    localStorage.setItem('coordinates', JSON.stringify(coordinates))
    });
  },  
};
</script>

<template>
  <div id="app">
    <RouterView />
    <Toasts :rtl="true" :max-messages="7" :showProgress="false" :time-out="5000" :closeable="false"></Toasts>
  </div>
</template>
